import tour13Gif from '../../../assets/images/tour-images/tour-13.gif';
import tour14Gif from '../../../assets/images/tour-images/tour-14.gif';

export const tourText = {
  createLesson: {
    title: 'Create a lesson',
    description:
      'Start a new microlesson from scratch or from a prompt — your AI-powered creation begins here.',
    image: tour13Gif,
  },
  kebabMenu: {
    title: 'Lesson actions',
    description:
      'Open this menu on any lesson card to edit, preview, or delete the lesson.',
    image: tour14Gif,
  },
};
